
import '../../Pages/Client/AO/AODetails.scss';
import '../../Pages/Client/AO/Alertes.scss';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    Checkbox,
} from '@mui/material';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import Table from 'react-bootstrap/Table';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { exigencesEnum, niveauxLangue, niveauxSkill } from '../../data/Interfaces';
import usePersistedLanguage from '../../hooks/usePersistedLanguage';
import useRole from '../../hooks/useRole';
import useWindowSize from '../../hooks/useWindowSize';
//import { notSelectedFrameCvTheque, selectedFrameCvTheque } from '../../Styles/componentStyles';
import { getNomPrenomClearFromPersoData, isUrlFromCandidature, searchLabelInEnumByValue } from '../../Utils/utils';
import { buttonStyles, buttonStylesBlue } from '../docsAdministrative/JsObjectStyles';
import HeaderAoDescription from './HeaderAoDescription';
import QuillAdvancedTextArea from './QuillAdvancedTextArea';
import { TextFieldComponent } from './ReusableSmallComponents';

const AoDetailsComponent = ({ ao, isExpertAlreadyPostulate, isFromCreateAO }) => {
    AoDetailsComponent.propTypes = {
        ao: PropTypes.any,
        isExpertAlreadyPostulate: PropTypes.any,
        isFromCreateAO: PropTypes.bool,

    };
    const role = useRole();
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    const {pathname} = useLocation();
    const {device}=useWindowSize();
    usePersistedLanguage();
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignSelf: 'stretch', gap: '24px' }}>
            <div className='frame5Profile'>{((role=='esn') ? ((!pathname.includes('aoHTH') &&!pathname.includes('candidatures')) ?i18n.t('Mes appels d\'offres'):i18n.t('Appels d\'offres HTH')) :i18n.t('Appels d\'offres'))} &gt; <span style={{ color: 'rgba(39, 45, 60, 1)' }}> {isUrlFromCandidature(pathname) ? i18n.t('Mes candidatures') : i18n.t('AO et candidatures')} </span> </div>
            {(role == 'client' || role=='admin') &&
                <div className='frame7TableMissionBDCAdmin'>
                    <div className='frame8TableMissionBDCAdmin'>
                        {!isFromCreateAO &&
                        <Button
                            className='frame29CvTheque'
                            onClick={() => {
                                navigate(`/${role}/ao/${ao?._id}`, { replace: true });
                            }}
                            style={{...buttonStyles(),...{borderRadius:'60px'}}}
                        >
                            {i18n.t('Candidatures')}
                        </Button>}
                        <Button
                            className='frame31CvTheque'
                            onClick={() => {
                                navigate('.', { replace: true }
                                );
                                //navigate('/admin/InterruptionsMissions/Traitees');
                                //setAllInterruption(false);
                            }}
                            variant='test'

                            style={{...buttonStylesBlue(),...{background: '#E7EAF9',color:'#214DCE',borderRadius:'60px'}}}
                            //style={selectedFrameCvTheque}
                            //style={
                            //    allInterruption == false  ?
                            //        selectedFrameCvTheque:
                            //        notSelectedFrameCvTheque
                            //}
                        >
                            {i18n.t('Données AO')}
                        </Button>
                    </div>
                </div>
            }
            <div style={{ display: 'flex', gap: '24px', flexDirection: 'column', alignSelf: 'stretch' }}>
                <HeaderAoDescription
                    ao={ao}
                    isExpertAlreadyPostulate={isExpertAlreadyPostulate}
                    isUrlFromCandidature={isUrlFromCandidature(pathname)}
                    isFromCreateAO={isFromCreateAO}
                />
                <div style={{ display: 'flex', gap: '24px', flexDirection: 'column' }}>
                    {/*ajouter pour tester le borderRadius */}
                    {/*<ThemeProvider theme={CustomizedAccordion}>*/}
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                        //aria-controls="panel1a-content"
                        //id="panel1a-header"
                        >
                            <Typography><h4 className='titlesociete'>{i18n.t('Description')}</h4></Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className='Frame4LA'>
                                <h6 className='ContexteMissionLA'>
                                    {i18n.t('Contexte de la mission')}
                                </h6>
                                <div className='ContentMissionLA'>
                                    <QuillAdvancedTextArea
                                        value={ao?.description || i18n.t('pas de description')}
                                        readOnly={true}
                                        theme='bubble'
                                    />
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    {(role !='expert' ||  (role == 'expert' && (ao?.competencesData?.skillsTech.length>0 || ao?.competencesData?.skillsFonc.length>0))) &&
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                //aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography><h4 className='titlesociete'>{i18n.t('Compétences')}</h4></Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className='Frame4LA'>
                                    <div className='FrameTechLA'>
                                        <h6 className='TitleTechLA'>
                                            {i18n.t('Techniques')}
                                        </h6>
                                        {ao?.competencesData?.skillsTech.length ?
                                            (
                                                <>
                                                    <div style={{ display: 'flex', alignSelf: 'stretch' }}>
                                                        {device=='desktop' &&
                                                        <div className='CompeTechLA'>
                                                            <div style={{ display: 'flex', flexDirection: device=='desktop'?'row':'column', width: device=='desktop'?'60%':'100%', gap: '4px' }}>
                                                                <p className='TniveauLA'>
                                                                    {i18n.t('Compétence')}
                                                                </p>
                                                            </div>
                                                            <div style={{ display: 'flex', flexDirection: 'row', width: device=='desktop'?'20%':'100%', gap: '4px' }}>
                                                                <p className='TniveauLA'>
                                                                    {i18n.t('Niveau')}
                                                                </p>
                                                            </div>
                                                            <div style={{ display: 'flex', flexDirection: 'row', width: device=='desktop'?'20%':'100%', gap: '4px' }}>
                                                                <p className='TexpLA'>
                                                                    {i18n.t('Exigence')}
                                                                </p>
                                                            </div>
                                                            {/*<div style={{ display: 'flex', flexDirection: 'row', width: '20%', gap: '4px' }}>
                                                                <p className='TexpLA'>
                                                                Plus récente exp.
                                                                </p>
                                                            </div>*/}
                                                        </div>
                                                        }
                                                    </div>
                                                    <>
                                                        {Array.isArray(ao?.competencesData?.skillsTech) && ao?.competencesData?.skillsTech.map((techskill, i) =>
                                                            (
                                                                <div
                                                                    style={{ display: 'flex', alignSelf: 'stretch' }}
                                                                    key={i}
                                                                >
                                                                    {
                                                                        techskill.titre?.map((skillName, j) => (
                                                                            <div
                                                                                key={j}
                                                                                className='CompeTechLA'
                                                                            >
                                                                                <div style={{ display: 'flex', flexDirection: 'column', width: '60%', gap: '4px' }}>
                                                                                    {device!='desktop' &&
                                                                                    <p
                                                                                        className='TniveauLA'
                                                                                        style={{color:device=='desktop'?'#272D3C':'#214DCE'}}
                                                                                    >
                                                                                        {i18n.t('Compétence')}
                                                                                    </p>
                                                                                    }
                                                                                    <p className='skillLA' >{skillName}</p>
                                                                                </div>
                                                                                <div style={{ display: 'flex', flexDirection: 'column', width: device=='desktop'?'20%':'100%', gap: '4px' }}>
                                                                                    {device!='desktop' &&
                                                                                    <p className='TniveauLA'>
                                                                                        {i18n.t('Niveau')}
                                                                                    </p>
                                                                                    }
                                                                                    <p className='CniveauLA'>
                                                                                        {i18n.t(searchLabelInEnumByValue(niveauxSkill, techskill?.niveau)) || i18n.t('Non précisé')}
                                                                                    </p>
                                                                                </div>
                                                                                <div style={{ display: 'flex', flexDirection: 'column',width: device=='desktop'?'20%':'100%', gap: '4px' }}>
                                                                                    {device!='desktop' &&
                                                                                    <p className='TexpLA'>
                                                                                        {i18n.t('Plus récente exp.')}
                                                                                    </p>
                                                                                    }
                                                                                    <p className='CexpLA'>
                                                                                        {i18n.t(searchLabelInEnumByValue(exigencesEnum,techskill?.exigence) || i18n.t('Non précisé'))}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        ))
                                                                    }
                                                                </div>
                                                            )
                                                        )}
                                                    </>
                                                </>
                                            ) : <p className='AucuneD'>{i18n.t('Aucune donnée')}</p>
                                        }
                                    </div>

                                    <div className='FrameFoncLA'>
                                        <h6 className='TitleTechLA'>
                                            {i18n.t('Fonctionnelles')}
                                        </h6>
                                        {ao?.competencesData?.skillsFonc.length ?
                                            (
                                                <>
                                                    {device=='desktop' &&
                                                    <div className='CompeTechLA'>
                                                        <div style={{ display: 'flex', flexDirection: 'row', width: device=='desktop'?'60%':'100%', gap: '4px' }}>
                                                            <p className='TniveauLA'>
                                                                {i18n.t('Compétence')}
                                                            </p>
                                                        </div>
                                                        <div style={{ display: 'flex', flexDirection: 'row', width: device=='desktop'?'20%':'100%', gap: '4px' }}>
                                                            <p className='TniveauLA'>
                                                                {i18n.t('Niveau')}
                                                            </p>
                                                        </div>
                                                        <div style={{ display: 'flex', flexDirection: 'row',width: device=='desktop'?'20%':'100%', gap: '4px' }}>
                                                            <p className='TexpLA'>
                                                                {i18n.t('Exigence')}
                                                            </p>
                                                        </div>
                                                        {/*<div style={{ display: 'flex', flexDirection: 'row', width: '20%', gap: '4px'}}>
                                                            <p className='TexpLA'>
                                                            Plus récente exp.
                                                            </p>
                                                        </div>*/}
                                                    </div>
                                                    }
                                                    <>
                                                        {Array.isArray(ao?.competencesData?.skillsFonc) && ao?.competencesData?.skillsFonc.map((foncSkill, i) => (
                                                            <div
                                                                key={i}
                                                                className='CompeTechLA'
                                                            >
                                                                <div style={{ display: 'flex', flexDirection: 'column',width: device=='desktop'?'60%':'100%', gap: '4px' }}>
                                                                    {device!='desktop' &&
                                                                    <p
                                                                        className='TniveauLA'
                                                                        style={{color:device=='desktop'?'#272D3C':'#214DCE'}}
                                                                    >
                                                                        {i18n.t('Compétence')}
                                                                    </p>
                                                                    }
                                                                    <p className='skillLA' >{foncSkill.titre}</p>
                                                                </div>
                                                                <div style={{ display: 'flex', flexDirection: 'column',width: device=='desktop'?'20%':'100%', gap: '4px' }}>
                                                                    {device!='desktop' &&
                                                                    <p className='TniveauLA'>
                                                                        {i18n.t('Niveau')}
                                                                    </p>
                                                                    }
                                                                    <p className='CniveauLA'>
                                                                        {i18n.t(searchLabelInEnumByValue(niveauxSkill, foncSkill?.niveau)) || i18n.t('Non précisé')}
                                                                    </p>
                                                                </div>
                                                                <div style={{ display: 'flex', flexDirection: 'column',width: device=='desktop'?'20%':'100%', gap: '4px' }}>
                                                                    {device!='desktop' &&
                                                                    <p className='TexpLA'>
                                                                        {i18n.t('Exigence')}
                                                                    </p>
                                                                    }
                                                                    <p className='CexpLA'>
                                                                        {i18n.t(searchLabelInEnumByValue(exigencesEnum,foncSkill?.exigence)) || i18n.t('Non précisé')}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </>
                                                </>) : <p className='AucuneD'>{i18n.t('Aucune donnée')}</p>
                                        }
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    }
                    {(role !='expert' ||  (role == 'expert' && ao?.competencesData?.langues.length>0)) &&
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                id="panel1a-header"
                            >
                                <Typography><h4 className='titlesociete'>{i18n.t('Langues')}</h4></Typography>
                            </AccordionSummary>
                            {ao?.competencesData?.langues.length > 0 ?
                                (
                                    <>
                                        <AccordionDetails>
                                            <div className='FramelangueLA'>
                                                {device=='desktop' &&
                                                <div className='LangueLA'>
                                                    <div style={{ display: 'flex', flexDirection: 'row', gap: '4px',width: device=='desktop'?'33%':'100%'}}>
                                                        <p className='TniveaulangueLA'>
                                                            {i18n.t('Langue')}
                                                        </p>
                                                    </div>
                                                    <div style={{ display: 'flex', flexDirection: 'row', gap: '4px',width: device=='desktop'?'33%':'100%' }}>
                                                        <p className='TniveaulangueLA'>
                                                            {i18n.t('Niveau')}
                                                        </p>
                                                    </div>
                                                    <div style={{ display: 'flex', flexDirection: 'row', gap: '4px',width: device=='desktop'?'33%':'100%'}}>
                                                        <p className='TniveaulangueLA'>
                                                            {i18n.t('Exigence')}
                                                        </p>
                                                    </div>
                                                </div>
                                                }
                                                {Array.isArray(ao?.competencesData?.langues) && ao?.competencesData?.langues.map((langue, i) => (
                                                    <div
                                                        key={i}
                                                        className='LangueLA'
                                                    >
                                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', width: device=='desktop'?'33%':'100%' }}>
                                                            {device!='desktop' &&
                                                            <p
                                                                className='TniveaulangueLA'
                                                                style={{color:device=='desktop'?'#272D3C':'#214DCE'}}
                                                            >
                                                                {i18n.t('Langue')}
                                                            </p>
                                                            }
                                                            <p className='skillangueLA'>
                                                                {langue.langue}
                                                            </p>
                                                        </div>
                                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px',width: device=='desktop'?'33%':'100%'}}>
                                                            {device!='desktop' &&
                                                                <p className='TniveaulangueLA'>
                                                                    {i18n.t('Niveau')}
                                                                </p>
                                                            }
                                                            <p className='skillangueLA'>
                                                                {i18n.t(searchLabelInEnumByValue(niveauxLangue, langue?.niveau)) || i18n.t('Non précisé')}
                                                            </p>
                                                        </div>
                                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px',width: device=='desktop'?'33%':'100%'}}>
                                                            {device!='desktop' &&
                                                                <p className='TniveaulangueLA'>
                                                                    {i18n.t('Exigence')}
                                                                </p>
                                                            }
                                                            <p className='CexpLA'>
                                                                {i18n.t(searchLabelInEnumByValue(exigencesEnum,langue?.exigence)) || i18n.t('Non précisé')}
                                                            </p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </AccordionDetails>
                                    </>
                                ): <p className='AucuneD'>{i18n.t('Aucune donnée')}</p>
                            }
                        </Accordion>
                    }
                    {(role !='expert' ||  (role == 'expert' && ao?.competencesData?.certifs.length>0)) &&
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                //expandIcon={<ExpandMoreIcon />}
                                //aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography><h4 className='titlesociete'>{i18n.t('Certificats')}</h4></Typography>
                            </AccordionSummary>
                            {ao?.competencesData?.certifs.length>0 ?
                                (
                                    <>
                                        <AccordionDetails>
                                            <div className='FramecertifLA'>
                                                {device=='desktop' &&
                                                <div className='CertifLA' >
                                                    <div style={{ display: 'flex', flexDirection: 'row',width: device=='desktop'?'50%':'100%', gap: '4px' }}>
                                                        <p className='TniveauLA'>
                                                            {i18n.t('Certificat')}
                                                        </p>
                                                    </div>
                                                    <div style={{ display: 'flex', flexDirection: 'row',width: device=='desktop'?'50%':'100%', gap: '4px' }}>
                                                        <p className='CertifexigenceLA'>
                                                            {i18n.t('Exigence')}
                                                        </p>
                                                    </div>
                                                </div>
                                                }
                                                {Array.isArray(ao?.competencesData?.certifs) && ao?.competencesData?.certifs.map((certif, i) => (
                                                    <div
                                                        key={i}
                                                        className='CertifLA'
                                                    >
                                                        <div style={{ display: 'flex', flexDirection: 'column', width: device=='desktop'?'50%':'100%', gap: '4px' }}>
                                                            {device!='desktop' &&
                                                            <p
                                                                className='TniveauLA'
                                                                style={{color:device=='desktop'?'#272D3C':'#214DCE'}}
                                                            >
                                                                {i18n.t('Certificat')}
                                                            </p>
                                                            }
                                                            <p className='certifieLA'>
                                                                {certif?.titre}
                                                            </p>
                                                        </div>
                                                        <div style={{ display: 'flex', flexDirection: 'column', width: device=='desktop'?'50%':'100%', gap: '4px' }}>
                                                            {device!='desktop' &&
                                                            <p className='CertifexigenceLA'>
                                                                {i18n.t('Exigence')}
                                                            </p>
                                                            }
                                                            <p className='CertifniveauLA'>
                                                                {searchLabelInEnumByValue(exigencesEnum, certif?.exigence) || ' Non précisé'}
                                                            </p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </AccordionDetails>
                                    </>
                                ): <p className='AucuneD'>{i18n.t('Aucune donnée')}</p>
                            }
                        </Accordion>
                    }
                    {/* (role=='esn' && pathname.includes('aoHTH'))  (le cas où une ESN joue le rôle d’un expert)*/}
                    {(role =='admin' ||role=='client' || (role=='esn' && !pathname.includes('aoHTH')))  &&
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                            // aria-controls="panel1a-content"
                            // id="panel1a-header"
                            >
                                <Typography><h4 className='titlesociete'>
                                    {i18n.t('Equipe chargée du recrutement et/ou suivi du projet')}
                                </h4></Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Table
                                    striped
                                    bordered
                                    hover
                                    className='TabBox'
                                    style={{ width: '100%' }}
                                >
                                    <thead>
                                        <th className='firstabhd'>{i18n.t('Nom')}</th>
                                        {/*<th className='secondtabhd'>Rôle</th>*/}
                                        <th className='secondtabhd'>{i18n.t('Gestion des candidatures')}</th>
                                        <th className='lastabhd'>{i18n.t('Suivi projet')}</th>
                                    </thead>
                                    {(Array.isArray(ao?.membres) && ao?.membres?.length )? (
                                        <tbody>
                                            {ao?.membres?.map((membre, i) => (
                                                <tr key={i}>
                                                    <td style={{ width: '55%', textAlign: 'center' }}>
                                                        <TextFieldComponent
                                                            variant='standard'
                                                            value={getNomPrenomClearFromPersoData(membre?.collaboratorId?.persoData ?? membre?.collaboratorEsnId?.persoData)}
                                                            disabled
                                                        />
                                                    </td>
                                                    {/*<td style={{ width: '30%', textAlign: 'center' }}>
                                                        <TextFieldComponent
                                                            variant='standard'
                                                            value={membre?.role}
                                                            disabled
                                                        />
                                                    </td>*/}
                                                    <td style={{ textAlign: 'center' }}>
                                                        <Checkbox
                                                            // defaultChecked
                                                            checked={membre.receptionCandidatures}
                                                            // onChange={() => {
                                                            //     let newArr = [...membres];
                                                            //     newArr[i].receptionCandidatures = !membre.receptionCandidatures;
                                                            //     setMembres(newArr);
                                                            // }}
                                                            disabled
                                                            inputProps={{ 'aria-label': 'controlled' }}
                                                        />
                                                    </td>
                                                    <td style={{ width: '15%', textAlign: 'center' }}>
                                                        <Checkbox
                                                            // default Checked
                                                            checked={membre.suiviMission}
                                                            // onChange={() => {
                                                            //     let newArr = [...membres];
                                                            //     newArr[i].suiviMission = !membre.suiviMission;
                                                            //     setMembres(newArr);
                                                            // }}
                                                            disabled
                                                            inputProps={{ 'aria-label': 'controlled' }}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    ) : (
                                        <p className='IntitulePoste'>{i18n.t('aucun membre a afficher')}</p>
                                    )}
                                </Table>
                            </AccordionDetails>
                        </Accordion>
                    }
                </div>
            </div>
        </div>
    );
};

export default AoDetailsComponent;